module.exports = __webpack_public_path__ + "img/romania.532e6318.jpg";